import { authService } from "@/services/auth/authService";
import { redirect } from "react-router-dom";
import { eventBus } from "../event/eventBus";
import { RoleEnum } from "@/types/auth/roleEnum";

export const adminProtectedLoader = () => {
  const roles = authService.userData?.roles;
  if (!authService.getAccessToken() || !roles?.includes(RoleEnum.Admin)) {
    eventBus.emit("error", {
      message: "Yetkisiz işlem.",
      type: "error",
    });
    authService.clearTokens();
    throw redirect("/login");
  }
  return null;
};
